angular.module('unergie.main')
.directive('salesTunnelSaveDraft', (MetaWatcher, AlertManager) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        disableContractEdition: '=',
        draftServices: '=',
        validated: '=',
    },
    templateUrl: '/states/salesTunnelV2/component/salesTunnelSaveDraft.html',
    link($scope) {
        const logShootDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.LOG_SHOOT_DRAFT')
        $scope.isSaving = false

        $scope.canSaveDraftToUser = () => {
            const VALIDATOR_NAMES = [
                'isCivDefined',
                'isGivennameDefined',
                'isSnDefined',
                'isSecondNameWellDefined',
                'isMailDefined',
                'isPhoneDefined',
                'isBirthDateDefined',
            ]
            return _.every(_.map(_.pick($scope.validated, VALIDATOR_NAMES), (val) => { return _.isObject(val) ? val.value : val }))
        }

        $scope.saveDraftToUser = function () {
            logShootDraft('Préparation de la création du contrat...')
            $scope.isSaving = true
            $scope.draftServices.linkDraftToUser().then(() => {
                logShootDraft('Le contrat a été sauvegardé à l’utilisateur')
                AlertManager.success(`Le contrat a été sauvegardé pour l’utilisateur ${$scope.draft.mail}`)
            }).finally(() => {
                $scope.isSaving = false
            })
        }
    },
}))
